var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53822 45.9467V46.5994C9.53822 47.8112 10.0606 48.9733 10.9903 49.8306C11.9206 50.6874 13.1817 51.1688 14.4965 51.1688H32.9132C34.228 51.1688 35.4891 50.6874 36.4194 49.8306C37.3491 48.9733 37.8715 47.8111 37.8715 46.5994V45.9467C37.9284 43.6939 37.172 41.4873 35.7206 39.6736C34.2691 37.8604 32.2055 36.542 29.8535 35.9266C31.7141 34.3884 32.8165 32.2185 32.9068 29.9164C32.9979 27.6141 32.0682 25.3766 30.3329 23.7185C28.5974 22.0598 26.205 21.123 23.7048 21.123C21.2047 21.123 18.8122 22.0597 17.0768 23.7185C15.3413 25.3766 14.4117 27.6141 14.5028 29.9164C14.5932 32.2186 15.6956 34.3885 17.5562 35.9266C15.2042 36.542 13.1405 37.8604 11.6891 39.6736C10.2376 41.4873 9.48117 43.6939 9.53816 45.9467H9.53822ZM23.7049 23.7522C25.3953 23.7522 27.017 24.3712 28.213 25.4727C29.4083 26.5749 30.0799 28.0692 30.0799 29.6272C30.0799 31.1852 29.4082 32.6795 28.213 33.7817C27.017 34.8833 25.3955 35.5022 23.7049 35.5022C22.0143 35.5022 20.3928 34.8832 19.1968 33.7817C18.0015 32.6796 17.3299 31.1852 17.3299 29.6272C17.3299 28.0692 18.0015 26.5749 19.1968 25.4727C20.3928 24.3712 22.0143 23.7522 23.7049 23.7522ZM20.8716 38.1133H26.5382C28.8081 38.0667 30.9995 38.8768 32.6046 40.356C34.2098 41.8352 35.0889 43.8548 35.0382 45.9467V46.5994C35.0382 47.6812 34.087 48.5578 32.9132 48.5578H14.4966C13.3227 48.5578 12.3716 47.6812 12.3716 46.5994V45.9467C12.321 43.8548 13.2001 41.8353 14.8051 40.356C16.4102 38.8768 18.6016 38.0666 20.8716 38.1133Z",
    fill: "#613ED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9557 47.8123H59.1224C59.9047 47.8123 60.5391 47.2277 60.5391 46.5067C60.5391 45.7858 59.9047 45.2012 59.1224 45.2012H44.9557C44.1734 45.2012 43.5391 45.7858 43.5391 46.5067C43.5391 47.2277 44.1734 47.8123 44.9557 47.8123Z",
    fill: "#613ED2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2455 39.9801H55.7188C56.6827 39.9801 57.4643 39.4038 57.4643 38.6932C57.4643 37.9825 56.6827 37.4062 55.7188 37.4062H45.2455C44.2816 37.4062 43.5 37.9825 43.5 38.6932C43.5 39.4038 44.2816 39.9801 45.2455 39.9801Z",
    fill: "#613ED2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 66,
    height: 45,
    rx: 3,
    stroke: "#613ED2",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 30.2402,
    width: 9.83571,
    height: 2.57381,
    rx: 1.2869,
    fill: "#613ED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCard);
export default __webpack_public_path__ + "static/media/userCard.e4f38fcc77fd2eed67d7a2e54d295526.svg";
export { ForwardRef as ReactComponent };